export default {
    TOGGLE_CHILDREN: 'ROOM_PLANNING/ACTIONS/TOGGLE_CHILDREN',
    TOGGLE_CHILD_SIGNATURE_FIELDS: 'ROOM_PLANNING/ACTIONS/TOGGLE_CHILD_SIGNATURE_FIELDS',
    TOGGLE_STAFF_SIGNATURE_FIELDS: 'ROOM_PLANNING/ACTIONS/TOGGLE_STAFF_SIGNATURE_FIELDS',
    FETCH_ROOM_PLANNING: 'ROOM_PLANNING/ACTIONS/FETCH_ROOM_PLANNING',
    FETCH_ROOM_PLANNING_SUCCESS: 'ROOM_PLANNING/ACTIONS/FETCH_ROOM_PLANNING_SUCCESS',
    FETCH_ROOM_PLANNING_ABORTED: 'ROOM_PLANNING/ACTIONS/FETCH_ROOM_PLANNING_ABORTED',
    FETCH_ROOM_PLANNING_FAILED: 'ROOM_PLANNING/ACTIONS/FETCH_ROOM_PLANNING_FAILED',
    CHANGE_SORTING: 'ROOM_PLANNING/ACTIONS/CHANGE_SORTING',
};
